import React from "react";
import PropTypes from "prop-types";

const SustainabilityAndSystemsIllustration = props => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 292 292"
      fill={props.fill}
      style={props.style}
    >
      <rect width={props.width} height={props.height} fill="#FFF2EB" />
      <path
        d="M116.829 123.979C117.695 124.07 118.571 123.986 119.404 123.73C120.923 123.304 127.068 121.954 130.47 123.18C133.871 124.405 139.27 129.68 141.322 133.224C142.925 136.18 144.377 139.215 145.673 142.318L125.248 139.476L116.829 123.979Z"
        fill="#FFC9A0"
      />
      <path
        d="M88.4723 124.112C88.4723 124.112 82.0338 125.95 80.4797 126.447C78.9256 126.945 76.7321 128.072 75.6043 131.776C74.4764 135.479 71.2883 140.896 71.0041 145.843C70.7199 150.789 70.9331 153.906 69.9473 156.81C68.9616 159.714 67.3275 167.343 67.9669 170.735C68.6063 174.127 72.6914 182.164 75.6398 183.994C75.6398 183.994 78.6059 189.606 81.2524 189.322C83.8988 189.038 85.2131 191.311 85.4085 195.787C85.6039 200.263 86.4298 205.858 87.2468 212.785C88.0638 219.712 88.8897 226.781 90.3195 229.658C90.3195 229.658 92.2288 227.882 93.6586 227.669C93.6586 227.669 97.0688 228.246 103.898 231.026C110.727 233.805 130.833 233.299 133.994 231.656L134.625 224.445L135.895 230.395C140.723 228.985 145.04 226.209 148.328 222.402C148.328 222.402 140.335 174.731 139.074 165.655C137.813 156.579 137.831 149.786 136.685 145.39C135.54 140.994 134.483 138.285 133.257 133.57C132.032 128.854 126.544 121.891 117.849 123.241L88.4723 124.112Z"
        fill="#FFC9A0"
      />
      <path
        d="M115.063 105.412C115.063 105.412 113.482 122.631 114.175 124.78C114.175 124.78 119.352 130.109 117.399 136.84C117.399 136.84 92.1953 126.352 90.6323 123.981C89.0693 121.61 91.7691 122.551 90.6323 117.809C89.4956 113.067 115.063 105.412 115.063 105.412Z"
        fill="#A35D2A"
      />
      <path
        d="M78.0298 109.664C78.0298 109.664 73.2787 108.98 71.7423 105.419C71.4404 104.718 69.5844 105.019 70.7566 103.803C71.9289 102.586 71.8756 102.915 70.3126 101.538C68.7496 100.162 66.8847 98.8741 68.1546 98.1547C69.4245 97.4354 69.2913 97.3466 68.5009 96.2365C67.7105 95.1265 67.8171 93.3148 68.0569 91.9472C68.2967 90.5796 65.2151 92.3024 66.192 90.2865C67.1688 88.2706 68.7496 89.576 68.3055 87.9154C67.8615 86.2547 65.6414 86.0949 67.7194 85.8462L69.8241 85.5975C69.8241 85.5975 66.8847 83.2886 68.1191 81.8854C69.3535 80.4823 67.4974 80.1093 68.7318 78.866C69.9662 77.6227 71.5381 77.978 71.0585 75.5624C70.579 73.1469 70.4458 72.8183 72.5594 72.1878C74.673 71.5573 72.4972 69.1684 75.0282 68.5379C77.5592 67.9073 78.1009 68.68 78.6515 66.7617C79.2021 64.8435 77.3549 63.3871 79.6816 63.9555C82.0084 64.5238 79.5395 63.316 81.9373 62.8987C84.3351 62.4813 83.9177 60.6519 85.1521 62.8987C86.3865 65.1455 87.2923 60.6074 88.8464 60.7495C90.4006 60.8916 90.6226 59.2487 92.3987 60.4298C94.1748 61.611 90.6226 62.9342 93.5088 62.9342C96.395 62.9342 96.9189 62.1616 98.331 62.7921C99.743 63.4226 96.6081 61.3801 98.5086 61.9751C100.409 62.5701 99.8851 61.2913 100.853 62.8631C101.821 64.435 101.741 62.4724 104.192 62.7743C106.643 63.0763 107.318 63.769 107.318 63.769C107.212 63.9129 107.14 64.0793 107.109 64.2554C107.077 64.4316 107.087 64.6126 107.136 64.7844C107.186 64.9562 107.275 65.1143 107.396 65.2462C107.517 65.3781 107.666 65.4804 107.833 65.5451C109.103 66.1579 107.691 63.023 109.476 64.8613C111.261 66.6996 110.817 64.5505 111.705 65.625C112.593 66.6996 110.604 68.6 112.869 69.1773C115.133 69.7545 114.867 68.2892 115.151 70.7047C115.435 73.1203 117.247 72.2322 117.637 73.3068C118.028 74.3813 115.95 73.2268 118.25 76.859C120.55 80.4912 122.637 78.8483 121.376 80.7576C120.115 82.6669 118.366 83.3241 119.6 84.0701C120.834 84.816 122.264 84.0701 120.772 86.0327C119.28 87.9953 119.103 88.6258 119.6 89.7004C120.097 90.7749 120.026 90.7661 118.765 92.1426C117.504 93.5191 101.697 113.518 101.697 113.518L79.8237 110.135L78.0298 109.664Z"
        fill="#483000"
      />
      <path
        d="M107.326 81.8057C107.326 81.8057 110.754 88.5283 111.26 89.887C111.766 91.2458 115.479 99.7623 115.399 103.057C115.319 106.352 112.015 116.564 108.641 119.522C105.266 122.479 98.934 122.896 92.2557 119.522C85.5775 116.147 80.7731 102.72 80.0182 100.189C79.2634 97.6576 79.0058 85.3846 85.5065 81.8057C92.0071 78.2268 103.063 77.1966 107.326 81.8057Z"
        fill="#B6773D"
      />
      <path
        d="M113.198 94.7782C113.198 94.7782 114.424 89.583 115.862 89.5208C117.301 89.4587 119.344 90.1425 119.654 93.5615C119.965 96.9806 119.157 101.838 116.919 102.584L114.681 103.33L113.198 94.7782Z"
        fill="#B6773D"
      />
      <path
        d="M81.3245 104.015C81.3245 104.015 77.9587 100.41 75.8096 101.866C73.6605 103.322 74.9926 107.035 75.8096 107.736C76.6266 108.438 78.7669 111.288 79.9302 111.803C81.0936 112.319 84.7524 112.692 85.5073 111.28C86.2621 109.868 81.3245 104.015 81.3245 104.015Z"
        fill="#B6773D"
      />
      <path
        d="M116.455 92.7271C115.674 94.5654 115.235 96.5304 115.158 98.5261L117.822 96.6967L116.472 96.4214L116.455 92.7271Z"
        fill="#A35D2A"
      />
      <path
        d="M77.4248 105.748L82.2914 107.124L80.1156 108.989V107.497L77.4248 105.748Z"
        fill="#A35D2A"
      />
      <path
        d="M117.814 137.043C117.814 137.043 121.571 133.792 122.876 133.757C124.181 133.721 131.25 134.743 131.25 134.743L123.586 130.622C122.155 131.108 120.872 131.953 119.861 133.078C118.85 134.202 118.145 135.567 117.814 137.043Z"
        fill="#FFAD71"
      />
      <path
        d="M104.288 138.677C106.262 138.529 108.217 138.184 110.123 137.647C111.854 136.955 117.813 137.043 117.813 137.043L108.631 132.781L104.288 138.677Z"
        fill="#FFAD71"
      />
      <path
        d="M114.067 119.192C114.067 119.192 120.55 122.851 122.717 126.297C124.884 129.743 130.577 134.289 130.577 134.289C130.577 134.289 125.435 132.291 123.587 130.595C123.587 130.595 118.774 132.904 117.815 137.016C118.077 134.829 117.886 132.612 117.256 130.503C116.625 128.393 115.567 126.435 114.147 124.752C113.939 122.906 113.912 121.044 114.067 119.192Z"
        fill="#FFC9A0"
      />
      <path
        d="M90.7625 118.571C90.7625 118.571 93.2669 121.138 99.3057 123.544C105.345 125.951 110.264 130.045 111.419 130.649C112.573 131.253 116.561 131.714 117.813 137.069C117.813 137.069 111.117 134.787 110.007 134.734C108.897 134.681 106.952 138.002 104.288 138.704C101.624 139.405 104.883 136.439 98.5508 132.318C92.219 128.198 87.8408 125.782 87.7431 124.326C87.7273 123.668 87.8459 123.013 88.0918 122.402C88.3376 121.791 88.7055 121.237 89.1729 120.774C90.0787 119.61 89.8034 118.26 90.7625 118.571Z"
        fill="#FFC9A0"
      />
      <path
        d="M117.806 137.053L132.654 183.277"
        stroke="#FFAD71"
        strokeWidth="0.319703"
        strokeMiterlimit="10"
      />
      <path
        d="M136.606 138.908C136.002 138.153 135.539 137.296 135.239 136.377C134.351 134.245 130.967 128.118 130.967 128.118C130.967 128.118 132.903 132.469 133.516 134.636C134.129 136.803 134.733 138.783 134.733 138.783L136.606 138.908Z"
        fill="#FFAD71"
      />
      <path
        d="M106.075 137.797C105.849 138.043 105.569 138.235 105.258 138.357C104.947 138.479 104.611 138.528 104.278 138.501C103.945 138.473 103.622 138.37 103.335 138.199C103.047 138.028 102.803 137.793 102.62 137.513C101.04 135.381 100.658 133.623 96.5637 131.012C92.4698 128.401 88.5712 126.314 87.7453 124.298C87.7453 124.298 87.2835 125.746 90.4095 128.366C93.5354 130.985 98.402 132.948 99.5032 135.115C100.604 137.282 103.642 140.781 106.856 138.063L108.482 137.513L106.075 137.797Z"
        fill="#FFAD71"
      />
      <path
        d="M87.6278 173.25C87.6278 173.25 85.7807 171.714 85.6031 170.701C85.4695 169.818 85.1186 168.982 84.5818 168.268C84.0401 167.495 86.8907 159.476 87.3703 157.514C87.8498 155.551 89.2707 144.85 88.2584 141.173C87.246 137.497 86.5621 135.729 86.5621 135.729C87.3638 138.439 87.7588 141.252 87.7344 144.077C87.4857 147.763 86.7131 153.473 85.8783 156.031C85.0436 158.588 85.31 163.215 83.8713 163.632C82.4327 164.05 76.8468 165.355 75.3637 166.847C73.8806 168.339 73.108 173.224 73.108 173.224C73.108 173.224 73.9339 169.041 76.9711 167.38C78.8818 166.386 81.0541 166.011 83.1875 166.305C83.1875 166.305 80.0438 166.492 79.0935 168.57C78.4515 170.065 77.9722 171.626 77.6638 173.224C77.6638 173.224 80.8608 168.268 82.7168 168.268C83.1294 168.386 83.4971 168.626 83.7725 168.955C84.0479 169.284 84.2184 169.688 84.2621 170.115C84.3602 170.952 84.7526 171.727 85.3691 172.301C85.9856 172.875 86.7862 173.212 87.6278 173.25Z"
        fill="#FFAD71"
      />
      <path
        d="M133.826 201.721L134.625 224.375"
        stroke="#FFAD71"
        strokeWidth="0.319703"
        strokeMiterlimit="10"
      />
      <path
        d="M116.395 140.661L125.062 141.945L127.227 142.265L126.577 146.651L115.745 145.047C115.323 144.985 115.169 144.457 115.491 144.177L116.876 142.974L115.899 141.421C115.672 141.06 115.973 140.599 116.395 140.661Z"
        fill="#FFAEC0"
      />
      <path
        d="M125.531 118.762C125.286 118.268 124.688 118.065 124.194 118.309L113.73 123.477L143.18 178.017C143.427 178.474 143.983 178.666 144.458 178.458L152.178 175.081C152.699 174.853 152.925 174.235 152.673 173.725L125.531 118.762Z"
        fill="#6BDEEF"
      />
      <path
        d="M113.757 123.571L129.231 117.9L114.643 125.282L113.757 123.571Z"
        fill="#CAF8FF"
      />
      <path
        d="M117.919 122.026L113.759 123.572L144.653 180.93L147.018 179.055L117.919 122.026Z"
        fill="#A7F0F9"
      />
      <path
        d="M129.923 118.258C129.78 117.936 129.411 117.782 129.081 117.906L117.938 122.088L146.356 180.09L155.443 175.602L129.923 118.258Z"
        fill="#CAF8FF"
      />
      <path
        d="M125.721 145.77L139.192 139.118L141.294 143.731L128.089 150.252L125.721 145.77Z"
        fill="#FF8DA6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M189.625 134.281L202.258 135.225L202.33 134.262L189.697 133.318L189.625 134.281Z"
        fill="#FF8D38"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M201.783 153.288C201.715 153.545 201.868 153.81 202.126 153.879L206.555 155.06C206.813 155.129 207.077 154.975 207.146 154.718C207.215 154.46 207.062 154.196 206.804 154.127L202.374 152.946C202.117 152.877 201.852 153.03 201.783 153.288Z"
        fill="#FF8D38"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M202.127 157.546C202.059 157.803 202.212 158.068 202.47 158.136L205.521 158.949C205.779 159.017 206.043 158.864 206.112 158.606C206.181 158.349 206.027 158.084 205.77 158.015L202.718 157.203C202.46 157.135 202.196 157.288 202.127 157.546Z"
        fill="#FF8D38"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M199.812 160.72C199.743 160.977 199.895 161.242 200.153 161.311L204.558 162.492C204.816 162.561 205.08 162.409 205.149 162.151C205.218 161.893 205.066 161.629 204.808 161.56L200.403 160.378C200.146 160.309 199.881 160.462 199.812 160.72Z"
        fill="#FF8D38"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M200.153 164.978C200.085 165.236 200.238 165.5 200.496 165.569L203.547 166.381C203.805 166.449 204.069 166.296 204.138 166.038C204.207 165.781 204.053 165.516 203.796 165.448L200.744 164.635C200.486 164.567 200.222 164.72 200.153 164.978Z"
        fill="#FF8D38"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M197.817 168.15C197.748 168.408 197.901 168.672 198.159 168.741L202.589 169.922C202.846 169.991 203.111 169.838 203.18 169.58C203.248 169.322 203.095 169.058 202.837 168.989L198.408 167.808C198.15 167.739 197.886 167.892 197.817 168.15Z"
        fill="#FF8D38"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M198.188 172.408C198.119 172.665 198.271 172.93 198.529 172.999L201.556 173.811C201.813 173.88 202.078 173.727 202.147 173.47C202.216 173.212 202.064 172.948 201.806 172.879L198.779 172.066C198.522 171.997 198.257 172.15 198.188 172.408Z"
        fill="#FF8D38"
      />
      <path
        d="M193.19 174.255L201.459 188.75C202.345 188.996 203.255 176.15 203.501 175.264L216.15 127.473C216.396 126.587 215.855 125.676 214.969 125.43L206.7 123.24C205.814 122.994 204.904 123.535 204.658 124.421L191.984 172.213C191.763 173.123 192.304 174.034 193.19 174.255Z"
        fill="#FFAD71"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M211.67 128.431C211.602 128.689 211.755 128.953 212.013 129.022L215.064 129.834C215.322 129.902 215.586 129.749 215.655 129.491C215.723 129.234 215.57 128.969 215.312 128.901L212.261 128.089C212.003 128.02 211.739 128.173 211.67 128.431Z"
        fill="#FF7712"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M209.356 131.606C209.288 131.864 209.441 132.128 209.698 132.197L214.128 133.378C214.386 133.447 214.65 133.294 214.719 133.036C214.788 132.778 214.634 132.514 214.377 132.445L209.947 131.264C209.69 131.195 209.425 131.348 209.356 131.606Z"
        fill="#FF7712"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M209.702 135.864C209.634 136.121 209.787 136.386 210.045 136.454L213.096 137.266C213.354 137.335 213.618 137.182 213.687 136.924C213.755 136.666 213.602 136.402 213.345 136.333L210.293 135.521C210.035 135.453 209.771 135.606 209.702 135.864Z"
        fill="#FF7712"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M207.387 139.037C207.317 139.295 207.47 139.559 207.728 139.628L212.133 140.81C212.39 140.879 212.655 140.726 212.724 140.468C212.793 140.211 212.64 139.946 212.383 139.877L207.978 138.696C207.72 138.627 207.456 138.78 207.387 139.037Z"
        fill="#FF7712"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M207.735 143.294C207.665 143.552 207.818 143.817 208.076 143.886L211.103 144.698C211.36 144.767 211.625 144.614 211.694 144.357C211.763 144.099 211.61 143.834 211.353 143.765L208.326 142.953C208.068 142.884 207.804 143.037 207.735 143.294Z"
        fill="#FF7712"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M205.393 146.497C205.326 146.755 205.48 147.019 205.738 147.086L210.168 148.243C210.426 148.31 210.69 148.156 210.757 147.898C210.824 147.64 210.67 147.376 210.412 147.309L205.982 146.152C205.724 146.085 205.461 146.239 205.393 146.497Z"
        fill="#FF7712"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M205.766 150.755C205.699 151.013 205.853 151.277 206.111 151.344L209.138 152.131C209.396 152.198 209.66 152.044 209.727 151.786C209.794 151.527 209.639 151.264 209.381 151.197L206.354 150.409C206.096 150.342 205.833 150.497 205.766 150.755Z"
        fill="#FF7712"
      />
      <path
        d="M205.298 123.536C205.298 123.536 200.253 155.134 207.758 159.761L204.362 173.173L192.55 170.097L204.289 124.865C204.289 124.865 204.781 123.708 205.298 123.536Z"
        fill="#FF8D38"
      />
      <path
        d="M183.191 123.103C183.137 122.371 182.499 121.82 181.766 121.875L140.201 124.95C139.468 125.004 138.918 125.642 138.972 126.375L143.448 186.871C143.502 187.604 144.14 188.154 144.873 188.1L186.438 185.024C187.171 184.97 187.721 184.332 187.667 183.599L183.191 123.103Z"
        fill="#26C7D9"
      />
      <path
        d="M147.293 127.168C147.238 126.435 146.6 125.885 145.867 125.94L138.245 126.503C137.513 126.558 136.962 127.196 137.017 127.929L137.672 136.791C137.726 137.524 138.365 138.074 139.098 138.02L146.719 137.456C147.452 137.402 148.003 136.764 147.948 136.031L147.293 127.168Z"
        fill="#26C7D9"
      />
      <path
        d="M184.778 122.787C184.724 122.054 184.086 121.504 183.353 121.558L141.788 124.634C141.055 124.688 140.505 125.326 140.559 126.059L145.035 186.554C145.089 187.287 145.727 187.837 146.46 187.783L188.025 184.708C188.758 184.654 189.308 184.015 189.254 183.283L184.778 122.787Z"
        fill="#6BDEEF"
      />
      <path
        d="M160.842 130.129L192.015 133.168L191.192 152.171H157.303L159.388 131.321C159.461 130.591 160.111 130.058 160.842 130.129Z"
        fill="#26C7D9"
      />
      <path
        d="M206.097 135.978C206.152 135.245 205.602 134.607 204.869 134.552L163.307 131.449C162.574 131.394 161.935 131.944 161.881 132.677L157.787 187.505C157.733 188.238 158.283 188.876 159.015 188.931L200.578 192.034C201.311 192.089 201.95 191.539 202.004 190.806L206.097 135.978Z"
        fill="white"
      />
      <path
        d="M130.857 199.995H207.638C211.305 199.995 214.283 197.017 214.283 193.351V152.032H124.238V193.375C124.213 197.017 127.191 199.995 130.857 199.995Z"
        fill="#FFAD71"
      />
      <path
        d="M186.701 176.683L188.335 177.837L186.191 177.581H186.096L185.824 177.548L183.915 177.318L183.098 175.679L183.013 175.508L181.928 173.334L183.59 174.504L185.025 172.011C185.411 171.418 185.815 171.157 186.212 171.116C186.918 171.081 187.636 171.716 188.146 172.334C188.284 172.512 188.411 172.692 188.524 172.861L188.651 173.057L188.524 173.315L188.333 173.696C187.913 174.509 187.338 175.552 186.701 176.683Z"
        fill="white"
      />
      <path
        d="M182.372 184.523C182.584 184.507 182.822 184.494 183.085 184.481C184.008 184.435 185.19 184.41 186.487 184.398L186.674 182.397L187.524 184.384L187.563 184.472L187.671 184.724L188.426 186.489L187.417 188.017L187.311 188.177L185.973 190.203L186.155 188.177H183.284C182.577 188.142 182.153 187.92 181.917 187.595C181.534 187.002 181.723 186.065 182.005 185.312C182.113 185.043 182.236 184.779 182.372 184.523Z"
        fill="white"
      />
      <path
        d="M179.088 183.187C179.081 183.041 179.107 182.895 179.164 182.76L179.198 182.7L181.737 178.28L184.683 179.842C184.5 180.149 184.279 180.535 184.046 180.955L182.43 183.746C182.372 183.833 182.241 184.041 182.086 184.325L182.038 184.413C181.895 184.676 181.771 184.949 181.666 185.23C181.435 185.837 181.234 186.531 181.361 187.136L179.088 183.187Z"
        fill="white"
      />
      <path
        d="M188.52 172.265L188.386 172.094C187.98 171.587 187.474 171.072 186.888 170.878H191.451C191.581 170.945 191.695 171.04 191.784 171.157L191.818 171.217L194.371 175.637L191.546 177.408C191.37 177.096 191.144 176.715 190.899 176.297L189.284 173.507C189.238 173.412 189.122 173.195 188.954 172.918L188.901 172.833C188.784 172.637 188.657 172.447 188.52 172.265Z"
        fill="white"
      />
      <path
        d="M195.657 184.534C195.366 184.576 195.073 184.601 194.779 184.61C194.659 184.435 194.526 184.234 194.385 184.015C193.888 183.244 193.272 182.226 192.612 181.109L190.798 181.949L192.093 180.22L192.148 180.144L192.314 179.913L193.468 178.376L195.294 178.487L195.486 178.498L197.912 178.646L196.065 179.5L197.501 181.986C197.822 182.614 197.845 183.096 197.681 183.461C197.355 184.098 196.448 184.403 195.657 184.534Z"
        fill="white"
      />
      <path
        d="M190.844 184.936H194.06C194.166 184.936 194.41 184.953 194.733 184.936H194.833C195.133 184.928 195.432 184.899 195.728 184.849C196.372 184.752 197.069 184.572 197.529 184.156L195.248 188.106C195.125 188.186 194.986 188.237 194.84 188.256H189.674L189.554 184.923C189.919 184.936 190.366 184.936 190.844 184.936Z"
        fill="white"
      />
      <path
        d="M162.088 154.591V200.02L159.701 200.045L130.859 200.02C130.859 200.02 124.756 199.946 124.214 193.375L124.141 170.538H151.703L162.088 154.591Z"
        fill="#FF8D38"
      />
      <path
        d="M214.258 169.972L174.145 170.538L162.161 154.591L151.775 170.538H124.213V152.032H214.258V169.972Z"
        fill="#FF8D38"
      />
      <path
        d="M162.088 152.032L153.13 160.99C152.047 162.072 150.595 162.663 149.094 162.663H116.438C115.626 162.663 115.183 161.679 115.749 161.088L124.214 152.032H162.088Z"
        fill="#FFAD71"
      />
      <path
        d="M162.16 152.033L171.635 161.507C172.521 162.393 173.726 162.885 174.957 162.885H223.929C224.914 162.885 225.406 161.704 224.717 160.99L215.734 152.033H162.16Z"
        fill="#FFC9A0"
      />
      <path
        d="M216.765 196.323C216.765 196.323 216.072 192.353 214.643 192.078C213.213 191.802 212.44 192.966 212.751 194.849C213.062 196.731 215.335 199.733 216.765 196.323Z"
        fill="#B6773D"
      />
      <path
        d="M84.6164 189.376C84.6164 189.376 83.0446 178.177 87.627 173.249C91.6223 175.593 95.353 178.362 98.7544 181.508C103.799 186.001 112.777 190.965 112.777 190.965C112.777 190.965 118.94 188.239 120.938 187.928C122.936 187.617 127.75 185.939 128.709 184.713C129.668 183.488 130.964 185.708 130.05 187.164C129.135 188.621 123.922 193.061 123.922 193.061C123.922 193.061 134.037 200.867 136.355 200.867C135.073 201.578 133.606 201.888 132.146 201.755C131.492 202.376 130.653 202.763 129.757 202.858C128.861 202.953 127.959 202.749 127.19 202.279C127.19 202.279 124.659 203.984 122.581 202.599C122.581 202.599 120.432 204.251 119.171 203.141C117.91 202.031 111.178 200.636 110.352 199.819L84.6164 189.376Z"
        fill="#B6773D"
      />
      <path
        d="M213.314 196.667C213.314 196.667 211.538 194.199 209.433 194.518C207.329 194.838 208.954 197.183 209.815 198.142C210.677 199.101 215.25 200.895 213.314 196.667Z"
        fill="#B6773D"
      />
      <path
        d="M209.814 198.141C208.868 197.517 207.844 197.021 206.768 196.667C205.729 196.481 204.858 198.239 206.048 199.331C207.238 200.424 208.881 201.187 209.814 200.761C210.746 200.335 210.391 198.843 209.814 198.141Z"
        fill="#B6773D"
      />
      <path
        d="M206.05 199.349C206.05 199.349 204.274 198.185 204.052 199.002C203.83 199.819 204.523 201.951 205.473 201.782C206.423 201.613 207.684 200.521 207.249 200.254C206.814 199.988 206.05 199.349 206.05 199.349Z"
        fill="#B6773D"
      />
    </svg>
  );
};

SustainabilityAndSystemsIllustration.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  style: PropTypes.object,
  fill: PropTypes.string,
};

SustainabilityAndSystemsIllustration.defaultProps = {
  width: 292,
  height: 292,
  fill: "none",
  style: {},
};

export default SustainabilityAndSystemsIllustration;
